import { render, staticRenderFns } from "./checkgraduate.vue?vue&type=template&id=2f3b226a&scoped=true&"
import script from "./checkgraduate.vue?vue&type=script&lang=js&"
export * from "./checkgraduate.vue?vue&type=script&lang=js&"
import style0 from "./checkgraduate.vue?vue&type=style&index=0&id=2f3b226a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3b226a",
  null
  
)

export default component.exports